import React, { useState, useRef, useCallback } from "react";
import "./CommerceListing.css";
import "../createPostLayout.css";
import VerticalAd from "../../VerticalBanner";
import { uploadToS3 } from "../../../Utils/Utils.js"
import { apiUrl, jsonAuthHeaders } from "../../../config/api.js"
import { devLog } from "../../../config/devLog.js"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import VerifyCompanyModal from "../../../components/SignUpScreen/verifyModal/VerifyModal.js";

const CommerceListing = () => {
  const [formData, setFormData] = useState({
    category: "",
    location: "",
    pinCode: "",
    availableFrom: "",
    availableTo: "",
    additionalDetails: "",
  });

  const navigate = useNavigate()
  const [item, setItem] = useState({
    itemName: "",
    available: "",
    price: "",
    storeLink: "",
    pictures: [],
    images: [],
  });

  const fileInputRef = useRef(null);

  const [items, setItems] = useState([]);
  const [showVerifyModal,setShowVerifyModal] = useState(false)
    const { userId, userDetails } = useSelector((state) => state.userReducer);

  const [adsRailFilled, setAdsRailFilled] = useState(false);

  const handleVerticalAdSlotState = useCallback((status) => {
    setAdsRailFilled(status === "filled");
  }, []);

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const urls = files.map((file) => URL.createObjectURL(file));
    setItem({ ...item, pictures: urls, images:files });
  };

  const handleItemChange = (e) => {
    setItem({ ...item, [e.target.name]: e.target.value });
  };

  const handleAddCommerce = () => {
    const nameOk = String(item.itemName || "").trim();
    const availOk = String(item.available || "").trim();
    const priceOk = String(item.price || "").trim();
    if (nameOk && availOk && priceOk) {
      setItems([...items, item]);
      setItem({
        itemName: "",
        available: "",
        price: "",
        storeLink: "",
        pictures: [],
        images: []
      });
      if (fileInputRef && fileInputRef.current) {
        try {
          fileInputRef.current.value = "";
        } catch (e) {
          // ignore
        }
      }
    } else {
      toast.warn("Enter item name, availability, and price to add a commerce item.", {
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
  };

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

/*
const extractPictures = (data) => {
  return data.flatMap(item => 
    (item.images || []).map(pic => {
      const parts = pic.name?.split('.') || [];
      const extension = parts.length > 1 ? parts.pop() : '';
      const baseName = parts.join('.');
      const newName = `${baseName}-${item.itemName}.${extension}`;

      return {
        ...pic,
        name: newName,
      };
    })
  );
};
*/

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (items.length === 0 || (formData.category.trim() === "" || formData.location.trim() === "" || formData.pinCode.trim() === ""|| formData.availableFrom.trim() === "" || formData.availableTo.trim() === "")) {
      toast.warn("Please add at least one commerce item and fill all form fields", {
          isLoading: false,
          autoClose: 3000,
          closeOnClick: true
        });
      return;
    }
    devLog("Form Data Submitted", formData, items);
    const pictureGroups = items.map((row) =>
      Array.isArray(row.images) ? row.images : []
    );
    const filesToUpload = pictureGroups.flatMap((g) =>
      Array.isArray(g) ? g : []
    );
    devLog("commerce images to upload", filesToUpload.length);

    let imagesUrls = [];
    try {
      if (filesToUpload.length > 0) {
        imagesUrls = await uploadToS3(filesToUpload);
      }
    } catch (err) {
      devLog("Commerce upload error", err?.message);
      toast.error(
        err?.message?.includes("fetch") || err?.message?.includes("CORS")
          ? "Image upload failed: configure S3 bucket CORS for this site origin (see lambda/DEPLOY.md section 10b)."
          : err?.message || "Image upload failed."
      );
      return;
    }

    const toastId = toast.loading("Creating your Listing...", {
      position: "bottom-center",
      autoClose: false,
      closeOnClick: true,
    });
    try {
      const response = await fetch(apiUrl("createUtility"), {
        method: "POST",
        headers: jsonAuthHeaders(),
        body: JSON.stringify({
          categoryId: 2,
          createdBy: userId,
          listingCategory: formData.category,
          ...formData,
          utilities: items,
          pictures: Array.isArray(imagesUrls) ? imagesUrls.join(",") : "",
        }),
      });

      const data = await response.json();
      devLog(data);
      if (response.ok) {
        toast.update(toastId, {
          render: "Listing Created successfully 🎉",
          type: "success",
          isLoading: false,
          autoClose: 3000,
          closeOnClick: true,
        });
        setTimeout(() => {
          navigate("/home");
        }, 3000);
      } else {
        toast.update(toastId, {
          render: data.message || "Something went wrong 😕",
          type: "error",
          isLoading: false,
          autoClose: 3000,
          closeOnClick: true,
        });
      }
    } catch (err) {
      devLog("createUtility error", err?.message);
      toast.update(toastId, {
        render: err?.message || "Could not save listing.",
        type: "error",
        isLoading: false,
        autoClose: 4000,
        closeOnClick: true,
      });
    }
  };

  return (
    <div className="Commercecontainer">
                         {showVerifyModal&& <VerifyCompanyModal isOpen={showVerifyModal} onClose={()=>{setShowVerifyModal(false)}} message={"You cannot proceed further with verifying yourself as corporate NRI, Please verify your corporate mail ID."}/>}
      {!adsRailFilled && (
        <div className="create-post-ad-probe" aria-hidden>
          <VerticalAd onSlotStateChange={handleVerticalAdSlotState} />
        </div>
      )}
      <div
        className={`create-post-layout ${adsRailFilled ? "create-post-layout--with-ad" : ""}`}
      >
        <div className="create-post-main">
      <div className="commerce-header">
        <h3>Commerce Listing</h3>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div>
          <label>Category</label>
          <input
            name="category"
            placeholder="Category"
            value={formData.category}
            onChange={handleFormChange}
            required
          />
        </div>
        <div style={{display: "flex", gap: "10px"}}>
          <div style={{width:"100%"}}>
            <label>Location</label>
            <input
              name="location"
              placeholder="Location"
              value={formData.location}
              onChange={handleFormChange}
              required
            />
          </div>
          <div style={{width:"100%"}}>
            <label>Pin Code</label>
            <input
              name="pinCode"
              placeholder="Pin Code"
              value={formData.pinCode}
              onChange={handleFormChange}
              required
            />
          </div>
        </div>

        <div className="date-section">
          <label style={{textAlign:"left"}}>
            Available From:
            <input
              type="date"
              name="availableFrom"
              value={formData.availableFrom}
              onChange={handleFormChange}
            />
          </label>
          <label style={{textAlign:"left"}}>
            Available To:
            <input
              type="date"
              name="availableTo"
              value={formData.availableTo}
              onChange={handleFormChange}
            />
          </label>
        </div>

        <div className="commerce-form">
          <h4>Add Commerce Item</h4>
          <div>
            <label>Item Name</label>
            <input
              name="itemName"
              placeholder="Item Name"
              value={item.itemName}
              onChange={handleItemChange}
              // required
            />
          </div>
          <div>
            <label>Available</label>
            <select
              name="available"
              value={item.available}
              onChange={handleItemChange}
              // required
            >
              <option value="">Select Option</option>
              <option value="Available">Available</option>
              <option value="Not Available">Not Available</option>
            </select>
          </div>

          <div>
            <label>Price</label>
            <input
              name="price"
              placeholder="Price"
              value={item.price}
              onChange={handleItemChange}
              // required
            />
          </div>
          <div>
            <label>Store Link (optional)</label>
            <input
              name="storeLink"
              placeholder="https://..."
              value={item.storeLink}
              onChange={handleItemChange}
            />
          </div>
          <label>Upload Pictures (optional)</label>
          <input
            ref={fileInputRef}
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageUpload}
          />
          <div className="image-preview">
            {item.pictures.map((pic, index) => (
              <img key={index} src={pic} alt={`upload-${index}`} />
            ))}
          </div>

          <button type="button" className="add-btn" onClick={handleAddCommerce}>
            Add Commerce
          </button>
        </div>

        <div>
          <label>Enter Additional Details</label>
          <textarea
            name="additionalDetails"
            placeholder="Enter Additional Details"
            value={formData.additionalDetails}
            onChange={handleFormChange}
          />
        </div>

        {items.map((itm, index) => (
          <div key={index} className="item-card">
            <p><strong>Item - {index + 1}</strong></p>
            <p>📦 <strong>{itm.itemName}</strong></p>
            <p>Availability: {itm.available}</p>
            <p>Price: ${itm.price}</p>
            <p>Store Link: {itm.storeLink?.trim() ? itm.storeLink : "—"}</p>
            {itm.pictures?.length > 0 ? (
              <div className="image-preview">
                {itm.pictures.map((pic, idx) => (
                  <img key={idx} src={pic} alt={`item-${idx}`} />
                ))}
              </div>
            ) : null}
          </div>
        ))}

        <button
          type="button"
          className="submit-btn"
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.preventDefault();
            if (!userDetails?.is_verified) {
              setShowVerifyModal(true);
            } else {
              handleSubmit(e);
            }
          }}
        >
          Submit
        </button>
      </form>
        </div>
        {adsRailFilled && (
          <aside className="create-post-ads" aria-label="Advertisement">
            <div className="create-post-ads-inner">
              <span className="create-post-ads-label">Advertisement</span>
              <VerticalAd onSlotStateChange={handleVerticalAdSlotState} />
            </div>
          </aside>
        )}
      </div>
    </div>
  );
};

export default CommerceListing;
